import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f22830aa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22830aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f22830aa')) {
      api.createRecord('f22830aa', component.options)
    } else {
      api.reload('f22830aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f22830aa&scoped=true&", function () {
      api.rerender('f22830aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/index.vue"
export default component.exports